export enum TransactionTypeEnum {
  CAPTURE = "CAPTURE",
  REFUND = "REFUND"
}
